import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { SwiperOptions } from 'swiper';
import { SwiperComponent } from 'angular2-useful-swiper';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/_service/app.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PerfectScrollbarConfigInterface} from 'ngx-perfect-scrollbar';
import { ConfirmModalComponent } from 'src/@common/confirm-modal/confirm-modal.component';

@Component({
  selector: 'app-inter-modal',
  templateUrl: './inter-modal.component.html',
  styleUrls: ['./inter-modal.component.scss']
})
export class InterModalComponent implements OnInit {
  public configure: PerfectScrollbarConfigInterface = {};
  @ViewChild('usefulSwiper', { static: false }) usefulSwiper: SwiperComponent;
  config: SwiperOptions = {
    pagination: { el: '.swiper-pagination', clickable: true },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    spaceBetween: 30,
    initialSlide: 0,
  };
  confirmDialogRef: MatDialogRef<InterModalComponent>;
  confirmDialog:MatDialogRef<ConfirmModalComponent>;

  iocList :any[]=[];
  userDataList: any = { Department: {} };
  ioctopopup: any;
  constructor(
     public dialog: MatDialog,
    private route: ActivatedRoute,
    private appService: AppService,
    private router: Router,
    private spinner: NgxSpinnerService,
    public dialogRef: MatDialogRef<InterModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
  ) {
    this.iocList = data.detailList;
    console.log('this.iocList: ', this.iocList);
    this.userDataList = data.userList;
    console.log(this.userDataList)
    this.config.initialSlide = data.activeIndex;
    console.log("data comp",data)
    console.log("data",data.action)

    if (data.action === "ioctopopup") {
      this.ioctopopup = data;
    }

  }

  ngOnInit() {
  }





  next = () => {
    this.usefulSwiper.swiper.slideNext();
  }
  prev = () => {
    this.usefulSwiper.swiper.slidePrev();
  }
  closeModal = () => {
    this.dialogRef.close();
  }

  editModal = (id)=>
  {
    this.router.navigate(['/app/dashboard/interoffice/add-ioc'], {queryParams: {Id: id}} );
    this.dialogRef.close();
  }
  openModalviewioclist(detail: any,Type:string){
    this.confirmDialogRef = this.dialog.open(InterModalComponent, {
      autoFocus: false,
      panelClass: 'modal-sm',
      disableClose: true,
      data: { action: 'ioctopopup',data:detail,Type:Type}
    });

  }

}
